export default __webpack_public_path__ + "static/media/newHabitTrackerLoggedInAddHabitBig.38f701ce.png";